import React from 'react'
import I18n from 'i18n'
import Field from '../common/Field'

export default class SportProLogboek extends React.Component {
  render () {
    const values = this.props.data.values

    return (
      <>
        <div className='sport-fields'>
          {values.hours_worked && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.hours_worked')} value={values.hours_worked} />
          )}
          {values.act_activities && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_activities')} value={values.act_activities} />
          )}
          {values.perc_activities && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_activities')} value={`${values.perc_activities}%`} />
          )}
          {values.act_volunteers && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_volunteers')} value={values.act_volunteers} />
          )}
          {values.perc_volunteers && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_volunteers')} value={`${values.perc_volunteers}%`} />
          )}
          {values.act_board && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_board')} value={values.act_board} />
          )}
          {values.perc_board && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_board')} value={`${values.perc_board}%`} />
          )}
          {values.act_facility && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_facility')} value={values.act_facility} />
          )}
          {values.perc_facility && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_facility')} value={`${values.perc_facility}%`} />
          )}
          {values.act_municipality && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_municipality')} value={values.act_municipality} />
          )}
          {values.perc_municipality && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_municipality')} value={`${values.perc_municipality}%`} />
          )}
          {values.act_sportbond && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_sportbond')} value={values.act_sportbond} />
          )}
          {values.perc_sportbond && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_sportbond')} value={`${values.perc_sportbond}%`} />
          )}
          {values.act_social_orgs && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_social_orgs')} value={values.act_social_orgs} />
          )}
          {values.perc_social_orgs && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_social_orgs')} value={`${values.perc_social_orgs}%`} />
          )}
          {values.act_communication && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_communication')} value={values.act_communication} />
          )}
          {values.perc_communication && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_communication')} value={`${values.perc_communication}%`} />
          )}
          {values.act_finance && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_finance')} value={values.act_finance} />
          )}
          {values.perc_finance && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_finance')} value={`${values.perc_finance}%`} />
          )}
          {values.act_cohesion && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_cohesion')} value={values.act_cohesion} />
          )}
          {values.perc_cohesion && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_cohesion')} value={`${values.perc_cohesion}%`} />
          )}
          {values.act_identity && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.act_identity')} value={values.act_identity} />
          )}
          {values.perc_identity && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_identity')} value={`${values.perc_identity}%`} />
          )}
          {values.perc_other && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.perc_other')} value={`${values.perc_other}%`} />
          )}
          {values.contact_parties && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.contact_parties')} value={Array.isArray(values.contact_parties) ? values.contact_parties.join(', ') : values.contact_parties} />
          )}
          {values.contact_other && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.contact_other')} value={values.contact_other} />
          )}
          {values.contact_ranking && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.contact_ranking')} value={values.contact_ranking} />
          )}
          {values.challenging_activities_count && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenging_activities_count')} value={values.challenging_activities_count} />
          )}
          {values.challenging_activities && Array.isArray(values.challenging_activities) && values.challenging_activities.map((activity, index) => (
            <div key={index} style={{ marginTop: '1rem', paddingLeft: '1rem', borderLeft: '3px solid #eee' }}>
              {activity.challenge_title && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_title_number', { number: index + 1 })} value={activity.challenge_title} />
              )}
              {activity.challenge_action && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_action')} value={activity.challenge_action} />
              )}
              {activity.challenge_reflection && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_reflection')} value={activity.challenge_reflection} />
              )}
              {activity.challenge_awareness && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_awareness')} value={activity.challenge_awareness} />
              )}
              {activity.challenge_alternatives && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_alternatives')} value={activity.challenge_alternatives} />
              )}
              {activity.challenge_learning && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_learning')} value={activity.challenge_learning} />
              )}
              {activity.challenge_frequency && (
                <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_frequency')} value={activity.challenge_frequency} />
              )}
            </div>
          ))}
          {values.challenge_3_title && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_title')} value={values.challenge_3_title} />
          )}
          {values.challenge_3_action && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_action')} value={values.challenge_3_action} />
          )}
          {values.challenge_3_reflection && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_reflection')} value={values.challenge_3_reflection} />
          )}
          {values.challenge_3_awareness && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_awareness')} value={values.challenge_3_awareness} />
          )}
          {values.challenge_3_alternatives && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_alternatives')} value={values.challenge_3_alternatives} />
          )}
          {values.challenge_3_learning && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_learning')} value={values.challenge_3_learning} />
          )}
          {values.challenge_3_frequency && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.challenge_3_frequency')} value={values.challenge_3_frequency} />
          )}
          {values.insufficient_time && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.insufficient_time')} value={values.insufficient_time} />
          )}
          {values.obstacles && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.obstacles')} value={values.obstacles} />
          )}
          {values.skills_needed && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.skills_needed')} value={values.skills_needed} />
          )}
          {values.success_experience && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.success_experience')} value={values.success_experience} />
          )}
          {values.takeaways && (
            <Field title={I18n.t('questionnaires.sportpro_wekelijks_logboek.takeaways')} value={values.takeaways} />
          )}
        </div>
      </>
    )
  }
}
